import { UPDATE_ANTHE_DATA } from '../constants/actionTypes'

export default (state = '', action) => {
    switch (action.type) {
        case UPDATE_ANTHE_DATA:
            return action.payload
        default:
            return state
    }
}
